<template>
    <div>
        Redirecting to... <a :href="url">{{url}}</a>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                url: "https://www.teepublic.com/user/thouless_art"
            }
        },
        mounted() {
            window.location.replace(this.url);
        },
    }
</script>

<style scoped>

</style>